// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recording-consent-slider {
  --recording-consent-icon-bg: var(--colors-background-bg-warning-secondary, #fef0c7);
  --recording-consent-icon-fg: #dc6803;
}
.recording-consent-slider .recording-consent-slider__body {
  padding: var(--xl, 24px) var(--xl, 24px) var(--default, 16px) var(--xl, 24px);
}
.recording-consent-slider .recording-consent-slider__icon {
  display: flex;
  width: 48px;
  height: 48px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  border-radius: var(--full, 9999px);
  margin-bottom: 16px;
  color: var(--recording-consent-icon-fg);
  background: var(--recording-consent-icon-bg);
}
.recording-consent-slider h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: var(--font-size-text-lg, 18px);
  font-weight: var(--font-weight-normal-Semibold, 600);
  line-height: var(--font-line-height-text-lg, 28px);
  margin-bottom: 4px;
}
.recording-consent-slider p {
  color: var(--sdk-gloabl-text-color);
  font-size: var(--font-size-text-sm, 14px);
  font-weight: var(--font-weight-normal-Regular, 400);
  line-height: var(--font-line-height-text-sm, 20px);
  opacity: 0.6;
  margin: 0;
}
.recording-consent-slider .recording-consent-slider__actions {
  padding-top: 24px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.recording-consent-slider .recording-consent-slider__actions .kr-button-primary,
.recording-consent-slider .recording-consent-slider__actions .kr-button-secondary {
  flex: 1 1 auto;
  min-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/plugins/agentDesktop/recordingConsentSlider.scss"],"names":[],"mappings":"AAAA;EACI,mFAAA;EACA,oCAAA;AACJ;AACI;EACI,6EAAA;AACR;AAEI;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;EACA,mBAAA;EACA,uCAAA;EACA,4CAAA;AAAR;AAGI;EACI,mCAAA;EACA,yCAAA;EACA,oDAAA;EACA,kDAAA;EACA,kBAAA;AADR;AAII;EACI,mCAAA;EACA,yCAAA;EACA,mDAAA;EACA,kDAAA;EACA,YAAA;EACA,SAAA;AAFR;AAKI;EACI,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAHR;AAKQ;;EAEI,cAAA;EACA,YAAA;AAHZ","sourcesContent":[".recording-consent-slider {\n    --recording-consent-icon-bg: var(--colors-background-bg-warning-secondary, #fef0c7);\n    --recording-consent-icon-fg: #dc6803;\n\n    .recording-consent-slider__body {\n        padding: var(--xl, 24px) var(--xl, 24px) var(--default, 16px) var(--xl, 24px);\n    }\n\n    .recording-consent-slider__icon {\n        display: flex;\n        width: 48px;\n        height: 48px;\n        padding: 12px;\n        justify-content: center;\n        align-items: center;\n        border-radius: var(--full, 9999px);\n        margin-bottom: 16px;\n        color: var(--recording-consent-icon-fg);\n        background: var(--recording-consent-icon-bg);\n    }\n\n    h1 {\n        color: var(--sdk-gloabl-text-color);\n        font-size: var(--font-size-text-lg, 18px);\n        font-weight: var(--font-weight-normal-Semibold, 600);\n        line-height: var(--font-line-height-text-lg, 28px);\n        margin-bottom: 4px;\n    }\n\n    p {\n        color: var(--sdk-gloabl-text-color);\n        font-size: var(--font-size-text-sm, 14px);\n        font-weight: var(--font-weight-normal-Regular, 400);\n        line-height: var(--font-line-height-text-sm, 20px);\n        opacity: 0.6;\n        margin: 0;\n    }\n\n    .recording-consent-slider__actions {\n        padding-top: 24px;\n        margin-top: 12px;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        width: 100%;\n\n        .kr-button-primary,\n        .kr-button-secondary {\n            flex: 1 1 auto;\n            min-width: 0;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
